var chunkMapping = {
	"95": [
		30095
	],
	"116": [
		70116
	],
	"282": [
		20282
	],
	"882": [
		50882
	],
	"900": [
		40900
	],
	"1363": [
		71363
	],
	"1692": [
		31692
	],
	"1758": [
		81758
	],
	"1774": [
		61774
	],
	"1888": [
		41888
	],
	"2035": [
		62035
	],
	"2119": [
		12119
	],
	"2254": [
		2254
	],
	"2269": [
		52269
	],
	"2286": [
		82286
	],
	"2428": [
		62428
	],
	"2560": [
		32560
	],
	"2764": [
		72764
	],
	"2769": [
		62769
	],
	"2812": [
		72812
	],
	"2838": [
		82838
	],
	"2870": [
		62870
	],
	"2934": [
		2934
	],
	"3033": [
		93033
	],
	"3138": [
		63138
	],
	"3372": [
		43372
	],
	"3460": [
		93460
	],
	"3597": [
		23597
	],
	"3603": [
		83603
	],
	"3718": [
		63718
	],
	"3775": [
		3775
	],
	"3785": [
		93785
	],
	"3921": [
		13921
	],
	"4056": [
		44056
	],
	"4072": [
		64072
	],
	"4365": [
		4365
	],
	"4432": [
		44432
	],
	"4470": [
		74470
	],
	"5002": [
		75002
	],
	"5032": [
		5032
	],
	"5131": [
		15131
	],
	"5283": [
		55283
	],
	"5378": [
		75378
	],
	"5408": [
		25408
	],
	"5416": [
		95416
	],
	"5473": [
		55473
	],
	"5523": [
		45523
	],
	"5540": [
		15540
	],
	"5854": [
		95854
	],
	"6016": [
		96016
	],
	"6041": [
		86041
	],
	"6209": [
		26209
	],
	"6298": [
		66298
	],
	"6393": [
		46393
	],
	"6446": [
		56446
	],
	"6514": [
		26514
	],
	"6618": [
		36618
	],
	"6739": [
		86739
	],
	"6754": [
		76754
	],
	"6880": [
		66880
	],
	"7210": [
		27210
	],
	"7367": [
		77367
	],
	"7586": [
		77586
	],
	"7647": [
		77647
	],
	"7706": [
		7706
	],
	"7721": [
		47721
	],
	"7904": [
		87904
	],
	"8047": [
		78047
	],
	"8216": [
		38216
	],
	"8273": [
		88273
	],
	"8293": [
		88293
	],
	"8358": [
		98358
	],
	"8629": [
		38629
	],
	"8773": [
		18773
	],
	"8859": [
		88859
	],
	"9414": [
		99414
	],
	"9496": [
		39496
	],
	"9597": [
		99597
	],
	"9643": [
		39643
	],
	"9948": [
		7567
	]
};
var idToExternalAndNameMapping = {
	"2254": [
		"default",
		"./OrderEntryCartPage",
		6929
	],
	"2934": [
		"default",
		"./CataloguePage",
		27600
	],
	"3775": [
		"default",
		"./AddressSelectionPage",
		72103
	],
	"4365": [
		"default",
		"./ChangeEmailFailedMessagePage",
		72103
	],
	"5032": [
		"default",
		"./BasicSetup",
		6929
	],
	"7567": [
		"default",
		"./EditAddress",
		72103
	],
	"7706": [
		"default",
		"./OrderHistoryDetailRedirectPage",
		72103
	],
	"12119": [
		"default",
		"./CustomerRestrictionsPage",
		36464
	],
	"13921": [
		"default",
		"./OrderHistoryPage",
		72103
	],
	"15131": [
		"default",
		"./ABExperimentsPage",
		30441
	],
	"15540": [
		"default",
		"./AbandonedCartPage",
		6929
	],
	"18773": [
		"default",
		"./ShoppingListPage",
		72103
	],
	"20282": [
		"default",
		"./CustomerCartPage",
		6929
	],
	"23597": [
		"default",
		"./SupportToolPage",
		6929
	],
	"25408": [
		"default",
		"./PaymentPage",
		6929
	],
	"26209": [
		"default",
		"./HistoryListPage",
		72103
	],
	"26514": [
		"default",
		"./CustomerSearchPage",
		36464
	],
	"27210": [
		"default",
		"./PrivacyStatementPage",
		27600
	],
	"30095": [
		"default",
		"./CategoryConfigurationPage",
		73610
	],
	"31692": [
		"default",
		"./OrderEntrySearchPage",
		6929
	],
	"32560": [
		"default",
		"./ListOverviewPage",
		72103
	],
	"36618": [
		"default",
		"./LoginPage",
		27600
	],
	"38216": [
		"default",
		"./TermsPage",
		27600
	],
	"38629": [
		"default",
		"./SelectAddressHook",
		72103
	],
	"39496": [
		"default",
		"./FailedSubmitsPage",
		6929
	],
	"39643": [
		"default",
		"./StoreListOverviewPage",
		72103
	],
	"40900": [
		"default",
		"./ArticleFetcher",
		22186
	],
	"41888": [
		"default",
		"./LogoutPopup",
		27600
	],
	"43372": [
		"default",
		"./SubmitMessagePage",
		72103
	],
	"44056": [
		"default",
		"./SearchPage",
		78460
	],
	"44432": [
		"default",
		"./AccountSelectionPage",
		72103
	],
	"45523": [
		"default",
		"./ChangeEmailSuccessMessagePage",
		72103
	],
	"46393": [
		"default",
		"./FAQPage",
		27600
	],
	"47721": [
		"default",
		"./CategoryImagesChoosingPage",
		73610
	],
	"50882": [
		"default",
		"./ChangeEmailForm",
		72103
	],
	"52269": [
		"default",
		"./CustomerInformations",
		72103
	],
	"55283": [
		"default",
		"./CreativesManagementPage",
		30441
	],
	"55473": [
		"default",
		"./CampaignManagementPage",
		30441
	],
	"56446": [
		"default",
		"./LoyaltypointsPage",
		72103
	],
	"61774": [
		"default",
		"./MyCMRStatements",
		72103
	],
	"62035": [
		"default",
		"./AddAddress",
		72103
	],
	"62428": [
		"default",
		"./CategoryPage",
		78460
	],
	"62769": [
		"default",
		"./SavedCartPage",
		6929
	],
	"62870": [
		"default",
		"./AddAddressPageWithRedirect",
		72103
	],
	"63138": [
		"default",
		"./CheckoutInitPage",
		6929
	],
	"63718": [
		"default",
		"./SynonymsManagementPage",
		73610
	],
	"64072": [
		"default",
		"./AddressList",
		72103
	],
	"66298": [
		"default",
		"./LegalNoticePage",
		27600
	],
	"66880": [
		"default",
		"./ReorderPage",
		72103
	],
	"70116": [
		"default",
		"./SynonymEditingPage",
		73610
	],
	"71363": [
		"default",
		"./MetroXBrandBar",
		72103
	],
	"72764": [
		"default",
		"./DeliveryPage",
		6929
	],
	"72812": [
		"default",
		"./AnonCartPage",
		6929
	],
	"74470": [
		"default",
		"./CartPdfPage",
		6929
	],
	"75002": [
		"default",
		"./StoreListPageWrappers",
		27600
	],
	"75378": [
		"default",
		"./SavedCartsListPage",
		6929
	],
	"76754": [
		"default",
		"./OverviewSection",
		72103
	],
	"77367": [
		"default",
		"./ChangeEmailConfirmation",
		72103
	],
	"77586": [
		"default",
		"./StoreActivationPage",
		73610
	],
	"77647": [
		"default",
		"./CustomerPortalPage",
		72103
	],
	"78047": [
		"default",
		"./AnonCartDebugPage",
		6929
	],
	"81758": [
		"default",
		"./SummaryPage",
		6929
	],
	"82286": [
		"default",
		"./StoreListManagementPage",
		30441
	],
	"82838": [
		"default",
		"./OrderHistoryDetailPage",
		72103
	],
	"83603": [
		"default",
		"./HeaderEmployee",
		72103
	],
	"86041": [
		"default",
		"./Footer",
		27600
	],
	"86739": [
		"default",
		"./MyCompany",
		72103
	],
	"87904": [
		"default",
		"./LandingPage",
		72103
	],
	"88273": [
		"default",
		"./OrderHistoryParkingPage",
		72103
	],
	"88293": [
		"default",
		"./AddressSection",
		72103
	],
	"88859": [
		"default",
		"./CookieLawDisclaimer",
		27600
	],
	"93033": [
		"default",
		"./OrderConfirmationPage",
		6929
	],
	"93460": [
		"default",
		"./PaymentsPage",
		72103
	],
	"93785": [
		"default",
		"./UidispatcherApiModule",
		56190
	],
	"95416": [
		"default",
		"./PersonallistsCsvUploadPage",
		36464
	],
	"95854": [
		"default",
		"./OrderEntryNewCartPage",
		6929
	],
	"96016": [
		"default",
		"./DeliveryAddressList",
		72103
	],
	"98358": [
		"default",
		"./SearchComparisonPage",
		73610
	],
	"99414": [
		"default",
		"./PromotionsPage",
		78460
	],
	"99597": [
		"default",
		"./IdamCompatibleLogoutLink",
		27600
	]
};
var idToRemoteMap = {
	"2254": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"2934": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"3775": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"4365": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"5032": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"7567": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"7706": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"12119": [
		{
			"externalType": "script",
			"name": "ca_backoffice_ui",
			"externalModuleId": 36464
		}
	],
	"13921": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"15131": [
		{
			"externalType": "script",
			"name": "cia_backoffice_inspiration",
			"externalModuleId": 30441
		}
	],
	"15540": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"18773": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"20282": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"23597": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"25408": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"26209": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"26514": [
		{
			"externalType": "script",
			"name": "ca_backoffice_ui",
			"externalModuleId": 36464
		}
	],
	"27210": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"30095": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui",
			"externalModuleId": 73610
		}
	],
	"31692": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"32560": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"36618": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"38216": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"38629": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"39496": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"39643": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"40900": [
		{
			"externalType": "script",
			"name": "sd_pdp_ui",
			"externalModuleId": 22186
		}
	],
	"41888": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"43372": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"44056": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"44432": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"45523": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"46393": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"47721": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui",
			"externalModuleId": 73610
		}
	],
	"50882": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"52269": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"55283": [
		{
			"externalType": "script",
			"name": "cia_backoffice_inspiration",
			"externalModuleId": 30441
		}
	],
	"55473": [
		{
			"externalType": "script",
			"name": "cia_backoffice_inspiration",
			"externalModuleId": 30441
		}
	],
	"56446": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"61774": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"62035": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"62428": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"62769": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"62870": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"63138": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"63718": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui",
			"externalModuleId": 73610
		}
	],
	"64072": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"66298": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"66880": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"70116": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui",
			"externalModuleId": 73610
		}
	],
	"71363": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"72764": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"72812": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"74470": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"75002": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"75378": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"76754": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"77367": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"77586": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui",
			"externalModuleId": 73610
		}
	],
	"77647": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"78047": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"81758": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"82286": [
		{
			"externalType": "script",
			"name": "cia_backoffice_inspiration",
			"externalModuleId": 30441
		}
	],
	"82838": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"83603": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"86041": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"86739": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"87904": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"88273": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"88293": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"88859": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"93033": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"93460": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"93785": [
		{
			"externalType": "script",
			"name": "uidispatcher_api",
			"externalModuleId": 56190
		}
	],
	"95416": [
		{
			"externalType": "script",
			"name": "ca_backoffice_ui",
			"externalModuleId": 36464
		}
	],
	"95854": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"96016": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"98358": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui",
			"externalModuleId": 73610
		}
	],
	"99414": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"99597": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}